import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'This garden was transformed from a derelict overgrown space into a modern family entertainer. A dark grey coloured bluestone was used as paving at the front of the property to ground the space and respect the formality of the traditional façade of the house while providing a contemporary transition to the new development at the rear. New picket fencing and a sliding gate system complete the renovation and secure the additional off street parking. Traditional planting of Wisteria and Lavender are framed with fresh looking Viburnum on the front boundary.',
            'The rear of the property is defined by the entertaining area on a large timber deck with floating built in bench seating and generous rear garden. The well-proportioned lawn is framed with layers of tropical planting providing a lush backdrop to the garden and privacy to the rear of the home.'
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Design
          <br />Construction
          <br />Ongoing Maintenance
          </span>
          
          <b>Design Features</b>
          <br />Contemporary
          <br />Family
          <br />Entertainer
          </p>
        ),
        image : '../images/projects/cammeray-4.jpg',
        title : 'Cammeray'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/cammeray-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/cammeray-2.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/cammeray-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/cammeray-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/cammeray-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/cammeray-6.jpg'
    },
]

const PageCammeray = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageCammeray